import {AfterViewInit, Component, ComponentRef, OnInit, ViewChild} from "@angular/core";
import {NgbAccordionConfig, NgbModal} from "@ng-bootstrap/ng-bootstrap";
import {C4AParams} from "../../model/params";
import {EventsService} from "../../services/events.service";
import {ParametersService} from "../../services/parameters.service";
import {ProductService} from "../../services/product.service";
import {CartService} from "../../services/cart.service";
import {UserService} from "../../services/user.service";
import {RegionsService} from "../../services/regions.service";
import {MapService} from "../../services/map.service";
import {HttpClient} from "@angular/common/http";
import {SettingsService} from "../../services/settings.service";
import {saveAs} from 'file-saver';
import {
  textChooseTimespan,
  textInvalidTimespanRange,
  textInvalidTimespanWinterMonth,
  textValidTimespan
} from "../../var/constants";

@Component({
  selector: 'app-parameters',
  templateUrl: './parameters.component.html',
  styleUrls: ['./parameters.component.scss'],
  providers: [NgbAccordionConfig]
})
export class ParametersComponent implements OnInit, AfterViewInit {
  @ViewChild('help', {static: false}) help: ComponentRef<any> | undefined;

  // Show loading bar
  showLoader: boolean;
  showMatrix: boolean;
  showTimePeriod: boolean;

  // Decides whether the login component should be displayed or not
  reLogin: boolean;

  listOfObjectTypes: any;
  // Period

  maxDatePicker: { year: number, month: number, day: number };
  minEndDate: { year: number, month: number, day: number };

  params: C4AParams;

  validateProdukt: { type: string, message: string[] };
  hideHelp = false;

  selectedProduct: string | undefined;

  labels = {
    textChooseTimespan: textChooseTimespan,
    textValidTimespan: textValidTimespan,
    textInvalidTimespanRange: textInvalidTimespanRange,
    textInvalidTimespanWinterMonth: textInvalidTimespanWinterMonth
  }

  constructor(
    config: NgbAccordionConfig,
    private events: EventsService,
    private http: HttpClient,
    private parametersService: ParametersService,
    private productService: ProductService,
    private cartService: CartService,
    private userService: UserService,
    private regionService: RegionsService,
    private modalService: NgbModal,
    private mapService: MapService,
    private settings: SettingsService
  ) {
    this.validateProdukt = {
      type: '',
      message: []
    };
    const today = new Date();
    const maxDate = new Date(today.valueOf() - 48 * 60 * 60 * 1000);
    this.maxDatePicker = {
      year: maxDate.getFullYear(),
      month: maxDate.getMonth() + 1,
      day: maxDate.getDate()
    };
    this.minEndDate = {
      year: maxDate.getFullYear()-1,
      month: 1,
      day: 1
    };
    this.showMatrix = false;
    this.showTimePeriod = false;

    this.params = this.parametersService.getParams();

    this.reLogin = false;
    this.showLoader = false;
  }

  ngOnInit() {
    this.listOfObjectTypes = this.http.get('assets/json/objektarten.json')
      .subscribe(objectTypes => this.listOfObjectTypes = objectTypes);
    this.selectedProduct = this.productService.getSelectedProductId();
    this.showMatrix = this.selectedProduct !== 'LB';
    // this.showTimePeriod = this.selectedProduct === 'LB';
    this.params.checkboxLB = false; // this.selectedProduct !== 'LB';
    this.events.subscribe('user:logout', () => this.clearProduct());
  }

  getLocaleDateString(type: 'start' | 'end'): string {
    let localeDateString = '';
    let date;
    if (type === 'start' && this.params.startDate) {
      date = this.params.startDate;
    } else if (type === 'end' && this.params.endDate) {
      date = this.params.endDate;
    }
    if (date) {
      localeDateString = `${date.day}.${date.month}.${date.year}`;
    }
    return localeDateString;
  }

  async ngAfterViewInit() {
    // restore value for hideHelp
    this.hideHelp = await this.settings.get('hideTimeframeHelp') === 'true';
    if (!this.hideHelp) {
      this.openModal(this.help, 'lg');
    }
  }

  /**
   * There are some months which are not allowed to be part of the timespan
   * @param startDate starting date
   * @param endDate ending date
   * @returns true or false whether the timespan is valid
   */
  checkForRestrictionMonth(startDate: any, endDate: any): boolean {
    // Restricted months
    const winterMonth = [11, 12, 1, 2, 3];
    let counter = 0;
    let endForLoop = 12;
    // In this case more than one of the winter months are concerned
    if (startDate.year !== endDate.year) {
      return false;
    }
    // The month of the end date is bigger than the month of the start date
    // E.g. start date is 03 and end date is 09. The for-loop will stop at 09 and not at 12.
    if (endDate.month > startDate.month) {
      endForLoop = endDate.month;
    }
    for (let i = startDate.month; i <= endForLoop; i++) {
      // Checks if a winter month is affected
      if (winterMonth.includes(i)) {
        counter++;
      }
      // One restricted month is allowed
      if (counter >= 2) {
        return false;
      }
    }
    return true;
  }

  /**
   * Set the end date
   * @param event datepicker change event
   * @returns void
   */
  selectEndDate(event: any): void {
    const params: C4AParams = this.parametersService.getParams();
    params.endDate = event;
    if (params.startDate !== '') {
      params.validationDate = 1;
    }
  }

  /**
   * The user can 'upload' a local classification file.
   * @param event change event
   * @returns void
   */
  fileSelected(event: any): void {
    const validFileExtension = ['json', 'JSON'];
    const evtTarget = event.target;
    if (evtTarget.type === 'file' && evtTarget.value.length > 0) {
      if (validFileExtension.includes(evtTarget.value.split('.')[1])) {
        const reader = new FileReader();
        reader.onload = (evt: any) => {
          this.listOfObjectTypes = JSON.parse(evt.target.result);
        };
        reader.readAsText(event.target.files[0]);
      } else {
        // TODO throw message
      }
    } else {
      // TODO throw message
    }
  }

  matrixModelChange() {
    this.parametersService.getParams().matrix = this.listOfObjectTypes;
  }

  /**
   * The classification matrix can be stored locally
   * @returns void
   */
  saveMatrixLocal(): void {
    // A blob object represents a file-like object of immutable raw data
    const blob = new Blob([JSON.stringify(this.listOfObjectTypes)], {type: 'text/plain;charset=utf-8'});
    // FileSave library is the solution to saving files on client-side
    saveAs(blob, 'cop4all_matrix.json');
  }

  /**
   * A single product is added to the shoppping cart
   * @returns void
   */
  async addProductToCart() {
    this.showLoader = true;
    this.validateProdukt = await this.cartService.createProduct();
    if (this.validateProdukt.message.length === 0) {
      try {
        await this.userService.tokenIsValid();
        try {
          await this.cartService.addToCart();
          this.cartService.addProductToItems();
          this.showLoader = false;
          this.clearProduct();
          this.validateProdukt.type = 'success';
          this.validateProdukt.message = ['Der Auftrag wurde Ihrem Warenkorb hinzugefügt.'];
        } catch (e) {
          this.showLoader = false;
          this.validateProdukt.type = 'warning';
          this.validateProdukt.message = ['Beim Hinzufügen des Auftrages ist es zu einem Fehler gekommen.'];
        }
      } catch (e) {
        this.showLoader = false;
        this.reLogin = true;
      }
    } else {
      this.showLoader = false;
    }
  }

  /**
   * Reset all product parameters. The user can create a new product.
   * @returns void
   */
  clearProduct(): void {
    // reset all parameter variables like the order name or the upload id
    this.parametersService.reset();
    // reset all selected regions
    this.regionService.resetStates();
    // clear all geometries on the map
    this.mapService.clearMap();
    this.params = this.parametersService.getParams();
    this.modalService.dismissAll();
  }

  /**
   * Opens the url in a new tab
   * @returns void
   */
  navigateTo(url: string): void {
    window.open(url, '_blank');
  }

  onJobNameChange(event: any) {
    const pattern = /^[a-zA-Z0-9\-_.]*$/;
    if (!pattern.test(event.target.value)) {
      event.target.value = event.target.value.replace(/[^a-zA-Z0-9\-_.]/g, "");
    }
    this.params.jobName = event.target.value;
  }

  openModal(content: any, size: 'sm' | 'lg' | 'xl' = 'sm') {
    this.modalService.open(content, {size});
  }

  async toggleTimeframeHelp() {
    await this.settings.set('hideTimeframeHelp', this.hideHelp.toString());
  }

  onToDateChange(date: any) {
    this.params.endDate = date;
    const fromDateObj = new Date(date.year - 1, date.month - 1, date.day);
    this.params.startDate = {
      year: fromDateObj.getFullYear(),
      month: fromDateObj.getMonth() + 1,
      day: fromDateObj.getDate()
    };
  }

}
